class TypeUtilities {
	static isOfTypeString(type) {
		return Object.prototype.toString.call(type) === `[object String]`;
	}
	static isOfTypeNumber(type) {
		let isNumber = false;
		isNumber = Object.prototype.toString.call(type) === `[object Number]`;
		if (isNumber === false) {
			isNumber = TypeUtilities.isOfTypeInteger(type);
		}
		return isNumber;
	}
	static isOfTypeInteger(type) {
		return Number.isInteger(type);
	}
	static isOfTypeObject(type) {
		return Object.prototype.toString.call(type) === `[object Object]`;
	}
	static isOfTypeArray(type) {
		return Object.prototype.toString.call(type) === `[object Array]`;
	}
	static isOfTypeBoolean(type) {
		return Object.prototype.toString.call(type) === `[object Boolean]`;
	}
	static isOfTypeNull(type) {
		return Object.prototype.toString.call(type) === `[object Null]`;
	}
	static isOfTypeFunction(type) {
		const typeString = Object.prototype.toString.call(type);
		//is class
		if (typeString === `[object Function]` && /^\s*class\s+/.test(type.toString())) {
			return false;
		}
		else if (typeString === `[object Function]` || typeString === `[object AsyncFunction]`) {
			return true;
		}
		else {
			return false;
		}
	}
	static isOfTypeDate(type) {
		const typeString = Object.prototype.toString.call(type);
		if (typeString === `[object Date]`) {
			return true;
		}
		else {
			return false;
		}
	}
	static isOfTypUint8Array(type) {
		const typeString = Object.prototype.toString.call(type);
		if (typeString === `[object Uint8Array]`) {
			return true;
		}
		else {
			return false;
		}
	}
	static isOfTypeMap(type) {
		return Object.prototype.toString.call(type) === `[object Map]`;
	}
	static getType(obj) {
		const foundMatches = Object.prototype.toString.call(obj).match(/\[object (.*)]/);
		const typeFound = foundMatches[1].toLowerCase();
		if (typeFound === 'number' && TypeUtilities.isOfTypeInteger(obj)) {
			return 'integer';
		}
		else if (typeFound === 'asyncfunction') {
			return 'function'
		}
		return typeFound;
	}
	static isEqual(a, b) {
		const aType = TypeUtilities.getType(a);
		const bType = TypeUtilities.getType(b);

		if (aType !== bType) {
			return false;
		}
		else {
			if (TypeUtilities.isOfTypeArray(a) || TypeUtilities.isOfTypUint8Array(a)) {
				if (a.length !== b.length) {
					return false;
				}
				else {
					for (const [aIndex, aValue] of a.entries()) {
						if (TypeUtilities.isEqual(aValue, b[aIndex]) === false) {
							return false;
						}
					}
					return true;
				}
			}
			else if (TypeUtilities.isOfTypeObject(a)) {
				if (Object.keys(a).length !== Object.keys(b).length) {
					return false;
				}
				else {
					for (const key in a) {
						if (TypeUtilities.isEqual(a[key], b[key]) === false) {
							return false;
						}
					}
					return true;
				}
			}
			else if (TypeUtilities.isOfTypeFunction(a)) {
				return a.toString() === b.toString();
			}
			else {
				return a === b;
			}
		}
	}
}
export { TypeUtilities };
export default TypeUtilities;